import { render, staticRenderFns } from "./arrive_notice.vue?vue&type=template&id=00234218&scoped=true"
import script from "./arrive_notice.vue?vue&type=script&lang=js"
export * from "./arrive_notice.vue?vue&type=script&lang=js"
import style0 from "./arrive_notice.vue?vue&type=style&index=0&id=00234218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00234218",
  null
  
)

export default component.exports